<template>
  <ConfigErrorBoundary>
    <FileConverter :config="converterConfig" @batch-created="handleBatchCreated" @job-completed="handleJobCompleted" @batch-cleared="handleBatchCleared" @error="handleError" @credits-updated="handleCreditsUpdated" />
  </ConfigErrorBoundary>
</template>
<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';
const converterConfig = parseAndValidateConverterConfig('cr2-to-webp-converter', 'Canon CR2 → WebP');
function handleBatchCreated(batchId: string) { console.log('[CR2 to WebP] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[CR2 to WebP] Job completed:', jobId); }
function handleBatchCleared() { console.log('[CR2 to WebP] Batch cleared'); }
function handleError(error: Error) { console.error('[CR2 to WebP] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[CR2 to WebP] Credits updated:', credits); }
</script>
